import React from 'react'
import HeroSection from './TestingPage/HeroSection'
import TestingServices from './TestingPage/TestingServices'
import CodoidAPITesting from './TestingPage/Testingtools'
import ContactForm from './TestingPage/ConactForm'
import WhyChooseUs from './TestingPage/WhyChoose'
const TestingPage = () => {
  return (
    <div>
          <section>
               <HeroSection/>
      </section>
      
      <section>
        <TestingServices/>
      </section>


      <section>
        <CodoidAPITesting />
      </section>

     

      <section>
        <WhyChooseUs/>
      </section>
       <section>
        <ContactForm/>
      </section>
    </div>
  )
}

export default TestingPage
